import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import {NzUploadChangeParam, NzUploadFile, NzUploadXHRArgs} from "ng-zorro-antd/upload";
import {ActionAlert} from "../../../../core/dto/actionAlert";
import {NzModalService} from "ng-zorro-antd/modal";
import {ActivatedRoute, Router} from "@angular/router";
import {LoadingService} from "../../../../core/services/loading.service";
import {UploadService} from "../../../../core/services/upload.service";
import {NzMessageService} from "ng-zorro-antd/message";
import {GooglePlacesService} from "../../../../core/services/google-places.service";
import * as _ from "lodash";
import {AddDescriptionComponent} from "../../shared/add-description/add-description.component";
import {ExperienceService} from "../../../../core/services/experience.service";
import {ExperienceDTO} from "../../../../core/dto/experiences";
import {FormControl} from "@angular/forms";
import {SettingService} from "../../../../core/services/setting.service";
import {LanguageService} from "../../../../core/services/language.service";
import {AuthService} from "../../../../modules/auth/services/auth.service";
import {UserService} from "../../../../core/services/user.service";
import {SETTINGS} from "../../../../core/config/common.settings";
import {OpenAiService} from "../../../../core/services/open-ai.service";


const getBase64 = (file: File): Promise<string | ArrayBuffer | null> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

@Component({
  selector: "app-mc-experiences",
  templateUrl: "./mc-experiences.component.html",
  styleUrls: ["./mc-experiences.component.scss"]
})
export class McExperiencesComponent implements OnInit {


  constructor(private nzModalService: NzModalService,
              private route: ActivatedRoute,
              private experienceService: ExperienceService,
              private loadingService: LoadingService,
              private uploadService: UploadService,
              private msg: NzMessageService,
              private googlePlacesService: GooglePlacesService,
              private settingService: SettingService,
              private languageService: LanguageService,
              private authService: AuthService,
              private userService: UserService,
              private openAiService: OpenAiService,
              private router: Router,
              private translocoService: TranslocoService) {
  }

  rId: any = undefined;
  onEdit = false;
  formErrors: any;
  experienceDTO = new ExperienceDTO();
  pageType: string | any;
  experienceName = "";
  descriptions: any[] = [];

  fileList: NzUploadFile[] = [];
  previewImage: string | undefined = "";
  previewVisible = false;
  actionMessage = new ActionAlert();
  placeholderPath: any = "../assets/img/placeholder-image.png";
  searchName = "";
  googlePlaceDetails: any;
  isDetailsExist = false;
  experience: any;
  contexts: any[] = [];

  language: any = 'en';
  languageType: any;
  languageField = new FormControl();
  selectedLanguages: any = [];
  languages: any = [];
  title = '';
  url = '';
  translatedTitle = '';
  listOfOption: any = [];
  isHidden = false;
  userPreferredImage: string = '';

  protected readonly SETTINGS = SETTINGS;

  ngOnInit(): void {
    this.loadingService.start();
    this.alertMessageInfo();
    this.getLanguages().then();
    this.findBrand().then((data: any) => {
      this.addMissingTitles(this.experienceDTO.name, this.experienceDTO.area, data);
    });

    this.experienceService.onExperienceChange.next({});
    this.experienceService.onExperienceChange.subscribe(async (experience) => {
      if (!_.isEmpty(experience)) {
        this.experienceDTO = new ExperienceDTO(experience);
        this.pageType = "edit";
        try {
          const pref = await this.userService.getContentImagePreference('experiences', this.experienceDTO._id);
          this.userPreferredImage = pref?.imageUrl || this.experienceDTO.defaultImage || '';
        } catch {
          this.userPreferredImage = this.experienceDTO.defaultImage || '';
        }
        this.fileList = this.experienceDTO.images.map(
          (image: any, index: number) => ({
            uid: (index + 1).toString(),
            name: "image.png",
            status: "done",
            url: image,
          })
        );
      } else {
        this.pageType = "new";
        this.experienceDTO = new ExperienceDTO();
      }
      if (this.pageType === "edit") {
        this.experienceName = this.experienceDTO.area ? this.experienceDTO.name : this.experienceDTO.name;
        this.url = this.experienceDTO.url;
        this.filterContentByLanguage(this.language);
      }
    });

    this.rId = this.route.snapshot.paramMap.get("id");
    this.experienceService.getOneExperience(this.rId).then(() => {
      this.translateOnInit().then((response: any) => {
        this.translatedTitle = response;
      });
      this.loadingService.stop();
    });

    this.languageField.valueChanges.subscribe((lang: any) => {
      if (this.pageType === 'edit') {
        this.filterContentByLanguage(lang);
        this.languageType = this.languages?.find((l: any) => l.code === lang);
        this.translateOnInit().then((response: any) => {
          this.translatedTitle = response;
          this.isHidden = false;
        });
      }
    });
  }

  addEditDescription(description: any, keyword: any, contentType: string, queryData: any , descriptionType: string): void {
    this.nzModalService
      .create({
        nzTitle: description
          ? this.translocoService.translate('experiences.descriptionModal.editTitle')
          : this.translocoService.translate('experiences.descriptionModal.addTitle'),
        nzContent: AddDescriptionComponent,
        nzFooter: null,
        nzComponentParams: {
          description,
          keyword,
          contentType,
          queryData,
          descriptionType
        },
      })
      .afterClose.subscribe(data => {
      if (data) {
        if (!this.contexts) {
          this.msg.error(
            this.translocoService.translate('experiences.descriptionModal.missingNameError')
          );
        } else {
          const descriptionIndex = this.experienceDTO.contexts.findIndex(
            (context) => context.body === description || context.keyword === keyword
          );
          this.submit({...data, language: this.language}, descriptionIndex);
        }
      }
    });
  }

  handlePreview = async (file: NzUploadFile | any): Promise<void> => {
    if (!file.url && !file.preview) {
      // tslint:disable-next-line:no-non-null-assertion
      file.preview = await getBase64(file.originFileObj!);
    }
    this.previewImage = file.url || file.preview;
    this.previewVisible = true;
  }

  async submit(payload: any, descriptionIndex: number): Promise<any> {
    this.onEdit = true;
    this.loadingService.start();
    let changeablePayload = _.cloneDeep(payload);

    if (descriptionIndex > -1) {
      this.experienceDTO.contexts[descriptionIndex] = payload;
    } else {
      this.experienceDTO.contexts.push(payload);
    }
    changeablePayload = Object.assign({}, this.experienceDTO);
    this.experienceService.updateExperience({
      _id: this.experienceDTO._id,
      ...changeablePayload
    }).then(() => {
      this.loadingService.stop();
    });
  }

  async deleteDescription(description: string): Promise<any> {
    this.onEdit = true;
    this.nzModalService.confirm({
      nzTitle: this.translocoService.translate('experiences.descriptionModal.deleteTitle'),
      nzOkText: this.translocoService.translate('experiences.descriptionModal.yes'),
      nzOnOk: () => {
        this.loadingService.start();
        this.experienceDTO.contexts =
          this.experienceDTO.contexts.filter(
            (d: string) => d !== description
          );
        this.experienceService
          .updateExperience({...this.experienceDTO}).then(() => {
          this.loadingService.stop();
        });
      },
      nzCancelText: this.translocoService.translate('experiences.descriptionModal.no'),
      nzOnCancel: () => {
      },
    });
  }

  async addUpdateExperience(e: string): Promise<any> {
    this.loadingService.start();
    const payload = this.experienceDTO;
    switch (e) {
      case "ADD":
        this.experienceService
          .createExperience({...payload})
          .then(() => {
            this.actionMessage = new ActionAlert(
              true,
              true,
              this.translocoService.translate('experiences.messages.added'),
              "success"
            );
            this.loadingService.stop();
          })
          .catch((error: any) => {
            this.actionMessage = new ActionAlert(
              true,
              true,
              error.error?.message || this.translocoService.translate('experiences.messages.notAdded'),
              "error"
            );
            if (error.error.id){
              this.router.navigate(["/admin/content/experiences/edit/", error.error.id]);
              this.loadingService.stop();
            }
            this.loadingService.stop();
          });
        break;
      case "EDIT":
        this.onEdit = true;
        this.experienceService.updateExperience({
          ...payload
        }).then(() => {
          this.actionMessage = new ActionAlert(
            true,
            true,
            this.translocoService.translate('experiences.messages.updated'),
            "success"
          );
          this.loadingService.stop();
        })
          .catch((error: any) => {
            this.actionMessage = new ActionAlert(
              true,
              true,
              error.error?.message || this.translocoService.translate('experiences.messages.notUpdated'),
              "error"
            );
            this.loadingService.stop();
          });
        break;
    }
  }

  onRemove = (item: NzUploadXHRArgs | any): any => {
    return new Promise((resolve) => {
      this.nzModalService.confirm({
        nzTitle: this.translocoService.translate('experiences.imageModal.deleteTitle'),
        nzOkText: this.translocoService.translate('experiences.imageModal.yes'),
        nzOnOk: () => {
          this.loadingService.start();
          this.experienceDTO.images = this.experienceDTO.images.filter(
            x => x !== item.url
          );
          this.experienceService.updateExperience(this.experienceDTO).then(res => {
            this.loadingService.stop();
            resolve(true);
          }).catch(() => {
            this.loadingService.stop();
            resolve(false);
          });
        },
        nzCancelText: this.translocoService.translate('experiences.imageModal.no'),
        nzOnCancel: () => {
          this.ngOnInit();
          resolve(false);
        },
      });
    });
  }

  customUploadReq = (item: NzUploadXHRArgs | any) => {
    const formData = new FormData();
    formData.append("file", item.file);
    return this.uploadService.uploadFile(formData, item);
  }

  handleChange(event: NzUploadChangeParam): any {
    if (!event) {
      return;
    }

    // Keep the card list in sync and only show persisted URLs as saved.
    // Preserve existing entries by uid to avoid re-creating DOM nodes (prevents image flicker).
    const existingByUid = new Map(this.fileList.map(f => [f.uid, f]));

    this.fileList = (event.fileList || []).map((file) => {
      const responseUrl = (file as any)?.response?.url;
      if (file.status === 'done' && responseUrl) {
        return {
          ...(existingByUid.get(file.uid) || file),
          ...file,
          url: responseUrl,
        };
      }
      // For uploading/queued files, merge into the existing entry so the
      // object identity stays stable and *ngFor won't destroy the card.
      const existing = existingByUid.get(file.uid);
      if (existing) {
        return { ...existing, ...file };
      }
      return file;
    });

    // Remove any transient local preview files from persisted images.
    const persistedUrls = this.fileList
      .filter((f) => f.status === 'done' && !!f.url)
      .map((f) => f.url as string);

    this.experienceDTO.images = [...new Set(persistedUrls)];

    // Save only when all uploads are completed (done or error), and at least one succeeded.
    const allDone = this.fileList.every(
      (f) => f.status === 'done' || f.status === 'error'
    );

    const hasSuccessfulUpload = this.fileList.some(
      (f) => f.status === 'done' && !!f.url
    );

    if (allDone && hasSuccessfulUpload) {
      this.experienceService.updateExperience(this.experienceDTO).then(() => {
        this.msg.success(this.translocoService.translate('experiences.messages.updated'));
      }).catch(() => {
        this.msg.error(this.translocoService.translate('experiences.messages.notUpdated'));
      });
    }
  }

  download = async (originalFile: NzUploadFile | any): Promise<any> => {
    this.loadingService.start();
    try {
      const fileName: any = originalFile.url.split("/").pop();
      this.uploadService.downloadFile(fileName).subscribe((blob: Blob) => {
        const file: Blob = new Blob([blob], {
          type: "application/octet-stream",
        });
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement("a");
        link.href = fileURL;
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(fileURL);
        this.loadingService.stop();
      });
    } catch (e) {
      this.loadingService.stop();
    }
  }

  async setAsDefaultImage(file: NzUploadFile | any): Promise<void> {
    this.loadingService.start();
    try {
      await this.userService.saveContentImagePreference('experiences', this.experienceDTO._id, file.url);
      this.userPreferredImage = file.url;
      this.msg.success('Default image updated successfully');
    } catch {
      this.msg.error('Failed to update default image');
    } finally {
      this.loadingService.stop();
    }
  }

  async search(value: string): Promise<any> {
    try {
      if (value !== "") {
        this.googlePlacesService.postAutoComplete({
          input: value,
          primaryTypes: []
        }).then(res => {

          this.listOfOption = res.suggestions || [];
          this.listOfOption.push(this.manualDataInit(value));
        });
      }
    } catch (e) {
    }
  }

  reset(): void {
    this.searchName = "";
    this.isDetailsExist = false;
  }

  async selectedResult(data: any): Promise<any> {
    this.actionMessage.display = false;
    try {
      this.loadingService.start();
      if (data.placeId !== "") {
        this.googlePlaceDetails = await this.googlePlacesService.getPlaceDetails(data.placeId);
        const genTitles = this.generateTitles(data.structuredFormat.mainText.text, 1);
        this.isDetailsExist = true;
        const experience: any = {
          titles: genTitles,
          name: data.structuredFormat.mainText.text,
          area: data.structuredFormat.secondaryText.text,
          location: this.googlePlaceDetails.location,
          apiId: data.placeId,
          active: true,
          entryType: SETTINGS.ENTRY_TYPES.GOOGLE,
          cost: 0,
          notes: ""
        };
        this.experienceDTO = experience;
      } else {
        // manual added
        const genTitles = this.generateTitles(data.structuredFormat.mainText.text, 1);
        this.isDetailsExist = true;
        const experience: any = {
          titles: genTitles,
          name: data.structuredFormat.mainText.text,
          area: "",
          location: "",
          apiId: "",
          active: true,
          entryType: SETTINGS.ENTRY_TYPES.MANUAL,
          cost: 0,
          notes: ""
        };
        this.experienceDTO = experience;
      }

      this.loadingService.stop();
    } catch (e) {
      this.loadingService.stop();
    }
  }


  async findBrand(): Promise<any> {
    const user = await this.authService.getLoggedInUser();
    const brand = await this.settingService.findBrand(user.userId);
    this.selectedLanguages = brand?.selectedLanguages || [];
    return this.selectedLanguages;
  }

  async getLanguages(): Promise<any> {
    this.languages = await this.languageService.getContentLanguages();
  }

  getSelectedLanguagesObjectArray(): any {
    const arr: any = [];
    this.selectedLanguages?.forEach((lang: string) => {
      arr.push(this.languages?.find((l: any) => l.code === lang));
    });
    return arr;
  }

  generateTitles(tempName?: string, toggle?: number): any {
    if (toggle === 1) {
      return this.selectedLanguages.map((languageCode: any) => {
        return {name: tempName, language: languageCode};
      });
    }

    if (toggle === 2) {
      return this.selectedLanguages.map((languageCode: any, index: number) => {
        return {name: this.experienceDTO.titles[index].name, language: languageCode};
      });
    }

  }

  onTitleChange(value: any): void {
    this.title = value;
  }

  async updateTitle(pageType: string): Promise<any> {

    for (let i = 0; i < this.experienceDTO.titles.length; i++) {
      if (this.experienceDTO.titles[i].language === this.language) {
        this.experienceDTO.titles[i].name = this.title;
      }
    }

    await this.addUpdateExperience(pageType === 'new' ? 'ADD' : 'EDIT');
  }

  async updateUrl(pageType: string): Promise<any> {
    this.experienceDTO.url = this.url;
    await this.addUpdateExperience(pageType === 'new' ? 'ADD' : 'EDIT');
  }

  filterContentByLanguage(lang: string): void {
    this.title = this.experienceDTO.titles
      .filter(obj => obj.language === lang)
      .map(obj => obj.name)
      .join(', ');
    this.contexts = this.experienceDTO.contexts
      .filter(obj => obj.language === lang);
  }

  alertMessageInfo(): void {
    this.actionMessage = new ActionAlert(
      true,
      true,
      this.translocoService.translate('experiences.messages.defaultLanguage'),
      "info"
    );
  }

  private manualDataInit(name: string): any {
    return {
      placePrediction: {
        text: {text: name},
        placeId: "",
        structuredFormat: {
          mainText: {
            text: name,
          }
        },
        entry: "manual"
      }
    };
  }

  async translateOnInit(): Promise<any> {
    try {
      this.loadingService.start();
      const payload = `Translate the following text "${this.title || this.experienceDTO.titles[0].name}" into ${this.languageType?.name || "English"}.
       Please provide only text in translated form and without " " `;
      const response = await this.openAiService.askChatGPT({query: payload});
      this.loadingService.stop();
      return response.choices[0].message.content;
    } catch (e) {
    }
  }

  private addMissingTitles(name: string, area: string, languages: []): void {
    const nameInEnglish = name;
    if (nameInEnglish) {
      languages.forEach((language: string) => {
        const exists = this.experienceDTO.titles.some(title => title.language === language);
        if (!exists) {
          this.experienceDTO.titles.push({
            name: nameInEnglish,
            language,
          });
        }
      });
    }
  }
}
